// Model.js
// -----------------------
// @module Case
define("NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/OutstandingPaymentAndEvent/SuiteScript2/OutstandingPaymentAndEvent.Service.ss"
            ),
            true
        )
});
});
